import "./GdprPage.scss";
import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <article className="privacy-policy__article">
        <h1>INFORMÁCIE O SPRACÚVANÍ OSOBNÝCH ÚDAJOV</h1>
        <h2>(Zásady ochrany osobných údajov pre portál capoeira.sk)</h2>

        <p>
          Bezpečnosť vašich osobných údajov je pre nás prioritou. Tento dokument
          vám poskytuje podrobné informácie o tom, prečo, ako a na aký čas
          spracúvame vaše osobné údaje (prípadne osobné údaje vašich detí) pri
          využívaní služieb portálu capoeira.sk a pri účasti na aktivitách nášho
          občianskeho združenia.
        </p>

        <h2>1. Identifikačné údaje prevádzkovateľa</h2>
        <p>
          Prevádzkovateľom, ktorý určuje účely a prostriedky spracúvania vašich
          osobných údajov, je:
        </p>
        <ul>
          <li>
            <strong>Názov:</strong> Kvalitná škola, o. z.
          </li>
          <li>
            <strong>Sídlo:</strong> Karpatské námestie 7770/10A, 831 06
            Bratislava - mestská časť Rača
          </li>
          <li>
            <strong>IČO:</strong> 57302146
          </li>
          <li>
            <strong>Registrácia:</strong> Vedená v Registri občianskych združení
            Ministerstva vnútra SR pod číslom: VVS/1-900/90-73078
          </li>
          <li>
            <strong>E-mail:</strong>{" "}
            <a href="mailto:capoeira@capoeira.sk">capoeira@capoeira.sk</a>
          </li>
          <li>
            <strong>Telefónne číslo:</strong>{" "}
            <a href="tel:+421948748999">0948 748 999</a>
          </li>
        </ul>
        <p>
          <em>(ďalej len „Prevádzkovateľ“)</em>
        </p>

        <h2>
          2. Na aké účely, na akom právnom základe a aké údaje spracúvame?
        </h2>
        <p>
          Vaše osobné údaje spracúvame iba na odôvodnené účely a po nevyhnutnú
          dobu. Najčastejšie ide o tieto situácie:
        </p>

        <h3>A. Registrácia člena, správa členstva a organizácia tréningov</h3>
        <ul>
          <li>
            <strong>Účel:</strong> Prijatie za člena združenia, evidencia
            členov, správa predplatného (mesačné, štvrťročné, ročné členské),
            komunikácia ohľadom tréningov, zmien rozvrhu a organizácie činnosti
            združenia.
          </li>
          <li>
            <strong>Právny základ:</strong> Plnenie zmluvy (čl. 6 ods. 1 písm.
            b) GDPR) – zmluvný vzťah vzniká registráciou a súhlasom s VOP.
          </li>
          <li>
            <strong>Kategórie údajov:</strong> Meno, priezvisko, dátum narodenia
            (dôležité pre správne zaradenie do vekovej skupiny), adresa trvalého
            pobytu, e-mail, telefónne číslo. Ak je členom dieťa (mladšie ako 18
            rokov), spracúvame aj meno, priezvisko a kontaktné údaje jeho
            zákonného zástupcu.
          </li>
        </ul>

        <h3>B. Prihlásenie na skúšobný tréning zadarmo</h3>
        <ul>
          <li>
            <strong>Účel:</strong> Evidencia záujemcov o bezplatný skúšobný
            tréning, zaistenie voľnej kapacity a komunikácia pred konaním
            tréningu.
          </li>
          <li>
            <strong>Právny základ:</strong> Opatrenia pred uzatvorením zmluvy na
            žiadosť dotknutej osoby (čl. 6 ods. 1 písm. b) GDPR).
          </li>
          <li>
            <strong>Kategórie údajov:</strong> Meno, priezvisko záujemcu
            (prípadne dieťaťa), kontaktný e-mail a telefónne číslo.
          </li>
        </ul>

        <h3>C. Účtovná a daňová agenda</h3>
        <ul>
          <li>
            <strong>Účel:</strong> Plnenie zákonných povinností spojených s
            účtovníctvom, evidenciou platieb za členské príspevky a vystavovaním
            potvrdení o zaplatení.
          </li>
          <li>
            <strong>Právny základ:</strong> Plnenie zákonnej povinnosti (čl. 6
            ods. 1 písm. c) GDPR) v spojení najmä so zákonom o účtovníctve a
            zákonom o dani z príjmov.
          </li>
          <li>
            <strong>Kategórie údajov:</strong> Fakturačné a platobné údaje
            (meno, priezvisko, adresa, číslo účtu, variabilný symbol, suma).
          </li>
        </ul>

        <h3>D. Prezentácia činnosti združenia (Fotografie a videá)</h3>
        <ul>
          <li>
            <strong>Účel:</strong> Propagácia športovej činnosti Capoeira na
            webstránke capoeira.sk a sociálnych sieťach združenia (ilustračné
            fotky a videá z tréningov, workshopov, páskovania - Batizado).
          </li>
          <li>
            <strong>Právny základ:</strong> Súhlas dotknutej osoby (čl. 6 ods. 1
            písm. a) GDPR). Tento súhlas je dobrovoľný a môžete ho kedykoľvek
            odvolať.
          </li>
          <li>
            <strong>Kategórie údajov:</strong> Fotografie, videozáznamy z
            tréningov a klubových podujatí.
          </li>
        </ul>

        <h3>E. Informovanie o novinkách a podujatiach (Marketing)</h3>
        <ul>
          <li>
            <strong>Účel:</strong> Posielanie e-mailových informácií o letných
            táboroch, workshopoch, predaji klubového oblečenia alebo iných
            aktivitách združenia.
          </li>
          <li>
            <strong>Právny základ:</strong> Súhlas dotknutej osoby (čl. 6 ods. 1
            písm. a) GDPR) alebo oprávnený záujem Prevádzkovateľa (čl. 6 ods. 1
            písm. f) GDPR) v prípade existujúcich aktívnych členov.
          </li>
          <li>
            <strong>Kategórie údajov:</strong> Meno, e-mailová adresa.
          </li>
        </ul>

        <h2>3. Spracúvanie osobných údajov detí (maloletých osôb)</h2>
        <p>
          Keďže organizujeme tréningy Capoeira aj pre deti, ochrana ich súkromia
          je pre nás mimoriadne dôležitá.
        </p>
        <p>
          Ak má záujemca o členstvo menej ako 18 rokov, registračný formulár
          musí vyplniť a súhlas s týmito podmienkami udeliť jeho zákonný
          zástupca (rodič).
        </p>
        <p>
          Všetka oficiálna komunikácia prebieha primárne so zákonným zástupcom
          dieťaťa.
        </p>

        <h2>4. Doba uchovávania osobných údajov</h2>
        <p>Vaše údaje uchovávame len po dobu nevyhnutnú na splnenie účelu:</p>
        <ul>
          <li>
            <strong>Údaje o členstve:</strong> Po celú dobu trvania členstva v
            združení a následne maximálne 3 roky od ukončenia členstva (pre
            prípad riešenia prípadných právnych nárokov alebo neuhradených
            pohľadávok).
          </li>
          <li>
            <strong>Skúšobný tréning zadarmo:</strong> Ak po skúšobnom tréningu
            nedôjde k registrácii za člena, vaše kontaktné údaje vymažeme do 30
            dní od absolvovania tohto tréningu.
          </li>
          <li>
            <strong>Účtovné doklady:</strong> Uchovávajú sa po dobu 10 rokov
            nasledujúcich po roku, ktorého sa týkajú, ako to vyžaduje zákon o
            účtovníctve.
          </li>
          <li>
            <strong>Fotografie a marketingový súhlas:</strong> Do odvolania
            vášho súhlasu, najneskôr však do 5 rokov od jeho udelenia, resp. od
            ukončenia vašej aktívnej účasti v združení.
          </li>
        </ul>

        <h2>5. Kto sú príjemcovia vašich osobných údajov?</h2>
        <p>
          Osobné údaje držíme v bezpečí a nepredávame ich tretím stranám na
          komerčné účely. Pre zabezpečenie chodu združenia však využívame služby
          overených partnerov (sprostredkovateľov), s ktorými máme uzatvorené
          zmluvy o spracúvaní osobných údajov:
        </p>
        <ul>
          <li>
            <strong>Tréneri a inštruktori:</strong> Naši licencovaní tréneri,
            ktorí vedú lekcie, majú prístup k zoznamom členov pre účely
            dochádzky a bezpečnosti na tréningu.
          </li>
          <li>
            <strong>Poskytovatelia IT a webhostingu:</strong> Prevádzkovateľ
            serverov, na ktorých beží web capoeira.sk, a poskytovatelia
            CRM/databázových systémov na správu členov.
          </li>
          <li>
            <strong>Poskytovateľ platobnej brány a banka:</strong> Pre bezpečné
            spracovanie online platieb kartou a priradenie platieb na bankový
            účet združenia.
          </li>
          <li>
            <strong>Účtovná kancelária:</strong> Externý účtovník, ktorý
            spracúva našu účtovnú a daňovú agendu.
          </li>
          <li>
            <strong>Orgány verejnej moci:</strong> V prípade, ak nám takúto
            povinnosť ukladá zákon (napr. daňový úrad, Ministerstvo školstva,
            výskumu, vývoja a mládeže SR pri vykazovaní športovej činnosti detí
            a mládeže).
          </li>
        </ul>
        <p>
          <strong>Poznámka:</strong> Vaše osobné údaje neprenášame do tretích
          krajín mimo Európskeho hospodárskeho priestoru (EHP).
        </p>

        <h2>6. Aké sú vaše práva ako dotknutej osoby?</h2>
        <p>
          V súvislosti so spracúvaním osobných údajov máte podľa GDPR tieto
          práva:
        </p>
        <ul>
          <li>
            <strong>Právo na prístup k údajom (čl. 15 GDPR):</strong> Máte právo
            vedieť, či o vás spracúvame údaje, aké údaje to sú a získať k nim
            prístup.
          </li>
          <li>
            <strong>Právo na opravu (čl. 16 GDPR):</strong> Ak sú vaše údaje
            nesprávne alebo neúplné, máte právo požiadať o ich bezodkladnú
            opravu alebo doplnenie.
          </li>
          <li>
            <strong>Právo na vymazanie / „na zabudnutie“ (čl. 17 GDPR):</strong>{" "}
            Máte právo požadovať vymazanie svojich údajov, napríklad ak už nie
            sú potrebné na pôvodný účel alebo ak odvoláte svoj súhlas (a
            neexistuje iný právny základ).
          </li>
          <li>
            <strong>Právo na obmedzenie spracúvania (čl. 18 GDPR):</strong> V
            špecifických prípadoch (napr. ak namietate nesprávnosť údajov)
            môžete žiadať, aby sme vaše údaje dočasne obmedzili a nespracúvali
            ich.
          </li>
          <li>
            <strong>Právo na prenosnosť údajov (čl. 20 GDPR):</strong> Máte
            právo získať svoje údaje v štruktúrovanom, bežne používanom a
            strojovo čitateľnom formáte a preniesť ich k inému
            prevádzkovateľovi.
          </li>
          <li>
            <strong>Právo namietať (čl. 21 GDPR):</strong> Ak spracúvame údaje
            na základe nášho oprávneného záujmu, máte právo voči tomuto
            spracúvaniu namietať.
          </li>
          <li>
            <strong>Právo odvolať súhlas:</strong> Ak spracúvame údaje na
            základe vášho súhlasu (napr. posielanie noviniek, fotenie), môžete
            tento súhlas kedykoľvek odvolať e-mailom na{" "}
            <a href="mailto:capoeira@capoeira.sk">capoeira@capoeira.sk</a>. Odvolanie
            nemá vplyv na zákonnosť spracúvania pred jeho odvolaním.
          </li>
        </ul>

        <h2>7. Právo podať sťažnosť dozornému orgánu</h2>
        <p>
          Ak sa domnievate, že pri spracúvaní vašich osobných údajov porušujeme
          platné právne predpisy, máte právo podať sťažnosť (návrh na začatie
          konania o ochrane osobných údajov) na dozorný orgán:
        </p>
        <address>
          <strong>Úrad na ochranu osobných údajov Slovenskej republiky</strong>
          <br />
          Hraničná 12, 820 07 Bratislava 27
          <br />
          E-mail:{" "}
          <a href="mailto:statny.dozor@pdp.gov.sk">statny.dozor@pdp.gov.sk</a>
          <br />
          Web:{" "}
          <a
            href="https://dataprotection.gov.sk/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://dataprotection.gov.sk/
          </a>
        </address>

        <h2>8. Ako si uplatniť svoje práva?</h2>
        <p>
          Akékoľvek žiadosti, otázky alebo odvolanie súhlasu týkajúce sa ochrany
          osobných údajov môžete zaslať:
        </p>
        <ul>
          <li>
            <strong>E-mailom na:</strong>{" "}
            <a href="mailto:capoeira@capoeira.sk">capoeira@capoeira.sk</a>
          </li>
          <li>
            <strong>Písomne poštou na adresu:</strong> Kvalitná škola, o. z.,
            Karpatské námestie 7770/10A, 831 06 Bratislava
          </li>
        </ul>

        <p>
          <em>
            Tieto zásady sú platné a účinné od 15.07.2026. Prevádzkovateľ je
            oprávnený tieto zásady v prípade zmien legislatívy či procesov
            aktualizovať. Aktuálna verzia bude vždy dostupná na webe
            capoeira.sk.
          </em>
        </p>
      </article>
    </div>
  );
};

export default PrivacyPolicy;
